export function getRealNextPath(prevPath, nextPath) {
  const { childrenProp } = this.props;
  const ppLastIndex = prevPath.length - 1;
  const npLastIndex = nextPath.length - 1;

  if (prevPath.length < nextPath.length) {
    // move into deep
    let wasShifted = false;

    return nextPath.map((nextIndex, i) => {
      if (wasShifted) {
        return i === npLastIndex ? nextIndex + 1 : nextIndex;
      }

      if (typeof prevPath[i] !== 'number') {
        return nextIndex;
      }

      if (nextPath[i] > prevPath[i] && i === ppLastIndex) {
        wasShifted = true;
        return nextIndex - 1;
      }

      return nextIndex;
    });
  }

  if (prevPath.length === nextPath.length) {
    // if move bottom + move to item with children => make it a first child instead of swap
    if (nextPath[npLastIndex] > prevPath[npLastIndex]) {
      const target = this.getItemByPath(nextPath);

      if (target[childrenProp] && target[childrenProp].length && !this.isCollapsed(target)) {
        return nextPath
          .slice(0, -1)
          .concat(nextPath[npLastIndex] - 1)
          .concat(0);
      }
    }
  }

  return nextPath;
}

export function getPathById(id, items = this.getDefaultItems()) {
  const { childrenProp } = this.props;
  let path = [];

  items.every((item, i) => {
    if (item.id === id) {
      path.push(i);
    } else if (item[childrenProp]) {
      const childrenPath = this.getPathById(id, item[childrenProp]);

      if (childrenPath.length) {
        path = path.concat(i).concat(childrenPath);
      }
    }

    return path.length === 0;
  });

  return path;
}

export function getItemByPath(path, items = this.getDefaultItems()) {
  const { childrenProp } = this.props;
  let item = null;

  path.forEach((index) => {
    const list = item ? item[childrenProp] : items;
    item = list[index];
  });

  return item;
}

export function getItemDepth(item) {
  const { childrenProp } = this.props;
  let level = 1;

  if (item[childrenProp].length > 0) {
    const childrenDepths = item[childrenProp].map(this.getItemDepth);
    level += Math.max(...childrenDepths);
  }

  return level;
}

export function getSplicePath(path, options = {}) {
  const splicePath = {};
  const numToRemove = options.numToRemove || 0;
  const itemsToInsert = options.itemsToInsert || [];
  const lastIndex = path.length - 1;
  let currentPath = splicePath;

  path.forEach((index, i) => {
    if (i === lastIndex) {
      currentPath.$splice = [[index, numToRemove, ...itemsToInsert]];
    } else {
      const nextPath = {};
      currentPath[index] = { [options.childrenProp]: nextPath };
      currentPath = nextPath;
    }
  });

  return splicePath;
}
